/**
 * @file authRoutes.jsx
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since May 01, 2025 18:08
 */
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const Loader = (Component) => (props) =>
(
    <Component {...props} />
);

// auth pages
const LoginPassword = Loader(lazy(() => import('src/content/Auth/LoginPassword/LoginPasswordContainer')));
const LoginOtp = Loader(lazy(() => import('src/content/Auth/LoginOtp/LoginOtpContainer')));
const OtpSetup = Loader(lazy(() => import('src/content/Auth/OtpSetup/OtpSetupContainer')));

const authRoutes = [
    {
        path: '',
        element: <Navigate to="signin" replace />
    },
    {
        path: 'signin',
        element: <LoginPassword />
    },
    {
        path: 'otpLogin',
        element: <LoginOtp />
    },
    {
        path: 'otpSetup',
        element: <OtpSetup />
    },
];

export default authRoutes;
